module.exports = __webpack_public_path__ + "static/media/loading-error.f56d14ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/product-image/loading-error.svg
// module id = 401
// module chunks = 0 1 2